export const numDecBGRToStrHexRGB = (color: number | null): string => {
  if (color === null) {
    return '';
  } else if (color >= 0) {
    return (
      '#' +
      /* eslint-disable no-bitwise */
      (
        ((color & 0xff0000) >> 16) |
        (color & 0x00ff00) |
        ((color & 0x0000ff) << 16)
      )
        /* eslint-enable no-bitwise */
        .toString(16)
        .padStart(6, '0')
    );
  } else {
    return '#FFFFFF';
  }
};

export const strHexRGBToNumDecBGR = (str: string | null): number | null => {
  if (str === '' || str === null) {
    return null;
  }
  const color = Number.parseInt(str.slice(1), 16);
  return (
    // eslint-disable-next-line no-bitwise
    ((color & 0xff0000) >> 16) | (color & 0x00ff00) | ((color & 0x0000ff) << 16)
  );
};
